import { Flex } from '@kvdbil/components';
import { FlexProps } from '@kvdbil/components/types/components/Flex';
import React from 'react';
import { GoBack } from '~/App/shared/components/IconButtons/GoBack';

type Props = {
  onBack(): void;
  flexProps?: FlexProps;
};

const BackButton = ({ onBack, flexProps }: Props) => {
  return (
    <Flex justify={'right'} align={'center'} {...flexProps}>
      <GoBack onClick={onBack} />
    </Flex>
  );
};

export default BackButton;
